/**
 *
 * Footer
 *
 */

import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { isIE } from "react-device-detect";
import Grandpa from "images/Ouwd_opaake.png";
import { FormattedMessage } from "react-intl";
import PhoneOutlined from "images/PhoneIcon";
import messages from "./messages";
import ContactDetails from "./ContactDetails";

class FooterComponent extends PureComponent {
  static propTypes = {
    phoneContact: PropTypes.object,
    disablePun: PropTypes.bool,
  };

  state = { width: 0 };

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);

    this.updateDimensions();
  };

  updateDimensions = () => {
    this.setState({ width: document.documentElement.clientWidth });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    const render = (isIE && this.state.width >= 1252) || !isIE;
    if (render) {
      return (
        <Wrapper>
          <FooterWrapper>
            <StyledFooter>
              {this.props.phoneContact ? (
                <FooterContactDetailsWrapper>
                  <ContactDetails>
                    <PhoneOutlined />{" "}
                    <PhoneNumber>{this.props.phoneContact}</PhoneNumber>
                  </ContactDetails>
                  {!this.props.disablePun && (
                    <ContactDetails>
                      <FooterImageWrapper>
                        <FooterImage>
                          <img
                            src={Grandpa}
                            alt="Grandpa"
                            style={{ width: 50 }}
                          />
                        </FooterImage>
                        <FormattedMessage {...messages.assistantPun} />
                      </FooterImageWrapper>
                    </ContactDetails>
                  )}
                </FooterContactDetailsWrapper>
              ) : (
                ""
              )}
            </StyledFooter>
          </FooterWrapper>
        </Wrapper>
      );
    }
    return null;
  }
}

FooterComponent.propTypes = {
  phoneContact: PropTypes.object,
  disablePun: PropTypes.bool,
};

const PhoneNumber = styled.div`
  line-height: 2.8rem;
  width: 100%;
`;

const FooterImageWrapper = styled.div`
  width: 100%;
  display: inline-block;
`;

const FooterImage = styled.div`
  width: 50px;
  display: inline-block;
  margin-left: 15px;
  margin-right: 10px;
`;

const StyledFooter = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background-color: transparent;
`;

const FooterWrapper = styled.div`
  max-height: 100%;
  display: flex;
  justify-content: center;
  line-height: inherit;
`;

const FooterContactDetailsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: right !important;
  width: 100%;
  padding: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 50px;
  padding-right: 50px;

  ${({ theme }) => theme.tabletLandscapeUp`
    margin: 0;
  `};

  @media (max-width: 693px) {
    flex-direction: column;
  }

  ${({ theme }) => theme.phone`
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 25px;
    padding-right: 25px;
  `};
`;

const Wrapper = styled.div`
  /* position: absolute; */
  /* bottom: 0; */
  /* width: 100%; */
  margin-top: ${({ theme }) => theme.margin}rem;
  width: ${({ theme, width }) => width * theme.grid}rem;
  height: ${({ theme, height }) => height * theme.grid}rem;
  line-height: ${({ theme, height }) => height * theme.grid}rem;
`;

export default FooterComponent;
